export const scheduleCard = [
  {
    title: "Belajar dengan guru dan teman sama, sesuai jadwal yang dipilih",
    subtitle: " ",
    info: [
      {
        bold: { text: "" }, // changed to an object with 'text'
        normal: [
          `<b>Metode belajar:</b> Kelas live online dengan interaksi 2-arah`
        ]
      },
      {
        bold: { text: "" },
        normal: [`<b>Untuk SD:</b> 4 pertemuan per bulan <br>(1 kelas/minggu)`]
      },
      {
        bold: { text: "" },
        normal: [
          `<b>Untuk SMP atau SMA: </b>8 pertemuan per bulan (2 kelas/minggu) `
        ]
      },
      {
        bold: { text: "" },
        normal: [
          `<b>Laporan belajar:</b> Kehadiran dan partisipasi dikirim ke WA orang tua`
        ]
      }
    ]
  }
];
